module.exports = __webpack_public_path__ + "static/media/GPG141B_H07_RK.d98a13ec.jpg";